import http from "../http";

const apiUrl = `${process.env.REACT_APP_API_URL}company-bank-account`;

export function getCompanyBankAccounts(params) {
  return http.get(apiUrl, { params });
}

export function getCompanyBankAccount(id) {
  return http.get(`${apiUrl}/${id}`);
}

export function saveCompanyBankAccount(data) {
  if (data.id) return http.patch(`${apiUrl}/${data.id}`, data);
  return http.post(apiUrl, data);
}

export function deleteCompanyBankAccount(id) {
  return http.delete(`${apiUrl}/${id}`);
}

export function uploadBankLogo(bankId, formData) {
  return http.post(`${apiUrl}/upload-bank-logo/${bankId}`, formData);
}


